import axios from 'axios'

const HTTP_PUBLIC = axios.create({
  baseURL: location.protocol + '//' + process.env.VUE_APP_BACKEND_BASE_URL + '/' + process.env.VUE_APP_BACKEND_APP_NAME  + '/public' ,
  headers: {
    'Content-Type': 'application/json',
    'x-ddol-apporg': 'eutils'
  }
})
// Por si queremos hacer algo antes de ejecutar el request.
HTTP_PUBLIC.interceptors.request.use(
  function (config) {
    config.headers.common['x-datadec-oid'] = localStorage.getItem("oid")

    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)
HTTP_PUBLIC.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    return Promise.reject(error)
  }
)

export default HTTP_PUBLIC
